import gql from 'graphql-tag'

export const StoreBankDetailsMutation = gql`
  mutation StoreBankDetailsMutation ($input: StoreBankDetailsInput!) {
    storeBankDetails(input: $input) {
      id
    }
  }
`
